

// PC端菜单栏切换：
// 切换菜单栏高亮显示


// 1、鼠标放在相应主菜单上，对应显示子菜单
// 获取所有的.nav a元素  遍历每个.nav a元素  
document.querySelectorAll('.nav a').forEach(function (link, index) {
  // 绑定mouseenter事件  
  link.addEventListener('mouseenter', function () {



    // 如果索引不是4，展开对应的.main_Submenu并设置.main_mask的高度  
    if (index !== 5) {
      // 获取对应的.main_Submenu元素  
      console.log(index);
      const Submenu = document.querySelector('.main_Submenu' + (index));
      // 注意：这里假设Submenu已经存在于DOM中，并且其scrollHeight是有效的  
      // 如果不是，你可能需要先显示Submenu再获取其scrollHeight  
      Submenu.style.height = Submenu.scrollHeight + 'px';
      // 设置.main_mask的高度  
      document.querySelector('.main_mask').style.height = '96vh';
    }

  });



  // 绑定mouseleave事件  
  link.addEventListener('mouseleave', function () {


    // 如果索引不是4，折叠对应的.main_Submenu并设置.main_mask的高度为0  
    if (index !== 5) {
      // 获取对应的.main_Submenu元素  
      let popup = document.querySelector('.main_Submenu' + (index));
      popup.style.height = '0';
      // 设置.main_mask的高度为0  
      document.querySelector('.main_mask').style.height = '0';
    }
  });
});
// 获取所有.main_Submenu元素  

document.querySelectorAll('.main_Submenu').forEach(function (main_Submenu, index) {
  // 悬停开始（mouseenter）时  
  main_Submenu.addEventListener('mouseenter', function () {

    main_Submenu.style.height = main_Submenu.scrollHeight + 'px';



    // 设置遮罩层的高度  
    var mask = document.querySelector('.main_mask');
    if (mask) {
      mask.style.height = '96vh';
    }
  });
  // 悬停结束（mouseleave）时  
  main_Submenu.addEventListener('mouseleave', function () {


    // 重置.main_Submenu元素的高度  
    main_Submenu.style.height = '0';

    // 重置遮罩层的高度  
    var mask = document.querySelector('.main_mask');
    if (mask) {
      mask.style.height = '0';
    }
  });

});
 /*处理product子菜单*/
 /*处理product子菜单*/
function indextopproduct() {
  // 二级
  $(".indextopproductleft .tbox1").hover(function () {
    $(this).addClass("on").siblings().removeClass("on")
    let num = $(this).index()
    $(".indextopproductcenter .tbox5").eq(num).addClass("on")
    $(".indextopproductcenter .tbox5").eq(num).siblings().removeClass("on")
    $(".indextopproductcenter .tbox5").eq(num).find(".tbox4").eq(0).addClass("on")
    $(".indextopproductcenter .tbox5").eq(num).find(".tbox4").eq(0).siblings().removeClass("on")
    let thisimg = $(".indextopproductcenter .tbox5").eq(num).find(".tbox4").eq(0).attr("data-img")
    let thisurl = $(".indextopproductcenter .tbox5").eq(num).find(".tbox4").eq(0).attr("data-url")
    $(".indextopproductright .timg").attr("href", thisurl)
    $(".indextopproductright .timg img").attr("src", thisimg)
    let thistrue = $(".indextopproductright .timg").attr("data-true")
    if (thistrue == "true") {
      console.log(1)
      $(".indextopproductright .timg img").removeClass("on2")
      $(".indextopproductright .timg img").addClass("on")
      $(".indextopproductright .timg").attr("data-true", "false")
    }
    else {
      console.log(2)
      $(".indextopproductright .timg img").removeClass("on")
      $(".indextopproductright .timg img").addClass("on2")
      $(".indextopproductright .timg").attr("data-true", "true")
    }
  })
  // 三级
  $(".indextopproductcenter .tbox5 .tbox4").hover(function () {
    $(this).addClass("on").siblings().removeClass("on")
    let thisimg = $(this).attr("data-img")
    let thisurl = $(this).attr("data-url")
    $(".indextopproductright .timg").attr("href", thisurl)
    $(".indextopproductright .timg img").attr("src", thisimg)
    let thistrue = $(".indextopproductright .timg").attr("data-true")
    if (thistrue == "true") {
      console.log(1)
      $(".indextopproductright .timg img").removeClass("on2")
      $(".indextopproductright .timg img").addClass("on")
      $(".indextopproductright .timg").attr("data-true", "false")
    }
    else {
      console.log(2)
      $(".indextopproductright .timg img").removeClass("on")
      $(".indextopproductright .timg img").addClass("on2")
      $(".indextopproductright .timg").attr("data-true", "true")
    }
  })
}
indextopproduct()
/*111*/
/*111*/


// 移动端菜单栏切换：
// 假设flag是一个全局变量  
let flag = true;

// 获取需要点击的元素  
const main_mleft = document.querySelector(".mobile_only .main .main_mleft");

// 添加点击事件监听器  
main_mleft.addEventListener('click', function () {
  // 获取其他相关元素  
  var mleft_line = document.querySelector('.mobile_only .main .mleft_line');
  var main_Submenu = document.querySelector('.mobile_only .main .main_Submenu');

  // 根据flag的值执行不同的操作  
  if (flag) {
    // 如果flag为true，执行以下操作  
    mleft_line.style.background = "transparent";
    this.classList.add("mleft_active");
    main_Submenu.style.height = "88vh";
    // 翻转flag的值  
    flag = false;
  } else {
    // 如果flag为false，执行以下操作  
    mleft_line.style.background = "black";
    this.classList.remove("mleft_active");
    main_Submenu.style.height = "0";
    // 翻转flag的值  
    flag = true;
  }
});





// 2、点击子菜单按钮，变换子菜单按钮形态，弹出子菜单栏
// 获取所有带有 .Submenu 类的元素  


// 为每个 .Submenu 元素添加点击事件监听器  
document.querySelectorAll('.mobile_only .Submenu').forEach(function (Submenu) {
  Submenu.addEventListener('click', function () {
    // 查找紧接着的 .Submenu_link 元素  
    const Submenu_link = Submenu.nextElementSibling;
    while (Submenu_link && !Submenu_link.classList.contains('Submenu_link')) {
      Submenu_link = Submenu_link.nextElementSibling;
    }

    if (!Submenu_link) {
      // 如果没有找到 .Submenu_link 元素，则不执行后续操作  
      return;
    }

    // 获取 .Submenu_link 元素的总高度（可能需要先设置为可见才能获取到实际高度）  
    // 注意：这里可能需要额外的逻辑来确保能够获取到正确的总高度  
    var totalHeight = Submenu_link.scrollHeight;

    // 获取当前 .Submenu_link 元素的高度样式  
    var currentHeightStyle = window.getComputedStyle(Submenu_link).getPropertyValue('height');

    // 检查当前高度是否为 0（可能需要转换为数字进行比较）  
    if (currentHeightStyle === '0px' || parseInt(currentHeightStyle, 10) === 0) {
      // 展开：添加 .Submenu_active 类到 .Submenu_right 子元素（假设它是 .Submenu 的直接子元素）  
      var mnavRight = Submenu.querySelector('.Submenu_right');
      if (mnavRight) {
        mnavRight.classList.add('Submenu_active');
      }

      // 设置 .Submenu_link 元素的高度为总高度  
      Submenu_link.style.height = totalHeight + 'px';
    } else {
      // 折叠：移除 .Submenu_active 类  
      var mnavRight = Submenu.querySelector('.Submenu_right');
      if (mnavRight) {
        mnavRight.classList.remove('Submenu_active');
      }

      // 设置 .Submenu_link 元素的高度为 0  
      Submenu_link.style.height = '0px';
    }
  });
});

